import UnitListing from '../unitMaster/listing';

const UnitReleaseListing = () => <UnitListing releaseMode />;

export default UnitReleaseListing;
